export const appConfig = {
  appName: "mesh-mood-check",
  storagePrefix: "mesh-mood-check",
  description:
    "Tap how you're doing — the room sees aggregate mood, never who said what. Ephemeral, peer-to-peer.",
  accentHex: "#f5a524",
  version: __APP_VERSION__,
  commit: __GIT_COMMIT__,
  repositoryUrl: "https://github.com/baditaflorin/mesh-mood-check",
  pagesUrl: "https://baditaflorin.github.io/mesh-mood-check/",
  signalingUrl:
    (import.meta.env.VITE_WEBRTC_SIGNALING as string | undefined) ?? "wss://turn.0docker.com/ws",
  turnTokenUrl:
    (import.meta.env.VITE_TURN_TOKEN_URL as string | undefined) ??
    "https://turn.0docker.com/credentials",
  paypalUrl: "https://www.paypal.com/paypalme/florinbadita",
} as const;
